import { MutationTree } from 'vuex';

import { subscribableStore } from './common';
import { UnitsState } from './types';

const mutations: MutationTree<UnitsState> = {
  ...subscribableStore.mutations,
};

export default mutations;
